import {BASE_DISCIPLINE_COLOR} from "../../constants/courseTypes";

export const getDisciplineColorFromId = (disciplineId: string, colors: {[key: string]: string}) => {
    if (Object.keys(colors || {}).includes(disciplineId)) return colors[disciplineId]
    return BASE_DISCIPLINE_COLOR
}import {BASE_DISCIPLINE_COLOR} from "../../constants/courseTypes";

export const getDisciplineColorFromId = (disciplineId: string, colors: {[key: string]: string}) => {
    if (Object.keys(colors || {}).includes(disciplineId)) return colors[disciplineId]
    return BASE_DISCIPLINE_COLOR
}